import { render, staticRenderFns } from "./Epicerie.vue?vue&type=template&id=088a66c9&"
import script from "./Epicerie.vue?vue&type=script&lang=js&"
export * from "./Epicerie.vue?vue&type=script&lang=js&"
import style0 from "./Epicerie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports